import React from 'react';

import { withTranslation } from 'react-i18next';
import { useHistory } from 'react-router';
import AccountCreated from '../AccountCreated';

export const SuccessResetPassword = ({ t }) => {
  const history = useHistory();
  return (
    <AccountCreated
      history={history}
      helperText
      subtitle={t('login.resetPassword.success.subtitle')}
    />
  );
};

export default withTranslation()(SuccessResetPassword);
